import { connect } from 'react-redux'
import {
  getFinanceProfiles,
  putFinanceProfileStatus,
} from 'reduxpath/ducks/FinanceProfile/List'

import Item from './units'

const mapStateToProps = state => ({
  financeStatus: state.FinanceProfileList.financeStatus,
  isWaiting: state.FinanceProfileList.financeStatus.waiting.value,
  userId: state.Auth.me.user.id,
})

const mapDispatchToProps = dispatch => ({
  handleVerify(id, skip, status, reviewedBy) {
    return (e) => {
      e.preventDefault()
      dispatch(putFinanceProfileStatus(id, {
        status,
        reviewedBy,
      }, () => {
        dispatch(getFinanceProfiles({
          sort: 'status ASC',
          limit: 10,
          skip,
        }))
      }))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Item)
